module.exports = __webpack_public_path__ + "img/competitors.a40d35da.png";